import { s3URL } from '@mathflat/common/util'
import React, { useState } from 'react'

import commonRepo from '@/repository/common.repo'
import modalService from '@/service/modal.service'
import { remoteStorageService } from '@/utils/axios/remoteStorage'

import GuideStepModal from './GuideStepModal'
import StartModal from './StartModal'

const RequiredConfirmModal = () => {
  const [step, setStep] = useState(0)

  const handleStart = () => {
    remoteStorageService.patch('STARTED_NEW_DESIGN_FLAT', true)
    modalService.closeModal()
  }

  switch (step) {
    case 0:
      return <StartModal onStart={() => setStep(1)} />
    case 1:
      return (
        <GuideStepModal
          videoUrl={`${s3URL.mathflatAssetsBucket.teacher(
            commonRepo.isSchoolflat
              ? 'assets/videos/required-guide-step1-school.mp4'
              : 'assets/videos/required-guide-step1.mp4',
          )}`}
          onNext={() => setStep(2)}
          title={
            <>
              <span className="step-badge">하나</span>더 많은 내용을, 한 눈에 확인할 수 있도록
            </>
          }
          description={
            <>
              불필요한 여백을 줄이고, 화면 공간을 더욱 효율적으로 사용할 수 있도록 개선했어요.
              <br /> 이제 더 많은 내용을, 한 눈에 확인해보세요!
            </>
          }
        />
      )
    case 2:
      return (
        <GuideStepModal
          videoUrl={`${s3URL.mathflatAssetsBucket.teacher(
            commonRepo.isSchoolflat
              ? 'assets/videos/required-guide-step2-school.mp4'
              : 'assets/videos/required-guide-step2.mp4',
          )}`}
          onPrev={() => setStep(1)}
          onNext={() => setStep(3)}
          title={
            <>
              <span className="step-badge">둘</span>구체적인 메뉴를 한 눈에 확인할 수 있도록
            </>
          }
          description={
            <>
              이제 메뉴가 화면 왼쪽에 사이드바 형태로 표시돼요.
              <br /> 메뉴를 더 쉽게 찾고, 우측 공간에서 콘텐츠에 집중할 수 있어요.
            </>
          }
          hasPrevButton
          nextButtonText="다음"
        />
      )
    case 3:
      return (
        <GuideStepModal
          videoUrl={`${s3URL.mathflatAssetsBucket.teacher(
            commonRepo.isSchoolflat
              ? 'assets/videos/required-guide-step3-school.mp4'
              : 'assets/videos/required-guide-step3.mp4',
          )}`}
          onPrev={() => setStep(2)}
          onNext={handleStart}
          title={
            <>
              <span className="step-badge">셋</span>빠르게 메뉴를 찾을 수 있도록
            </>
          }
          description={
            <>
              관리 메뉴가 더 쉬워졌어요. <br />
              관리 메뉴에서 한번의 클릭만으로 사용하려는 메뉴로 접근해보세요.
            </>
          }
          hasPrevButton
          nextButtonText="시작하기"
        />
      )
    default:
      return null
  }
}

export default RequiredConfirmModal
